module.exports = __webpack_public_path__ + "img/xmr.5a5b43d2.svg";